import type { QueryClient } from "@tanstack/react-query";

export const supplierQueryKeys = {
  all: ["network", "supplier"] as const,
  connectionList: () => ["network", "supplier", "connection-list"] as const,
  connectionListItem: (id: string) => ["network", "supplier", "connection-list", id] as const,
  supplierStats: () => ["network", "supplier", "supplier-stats"] as const,
  invitationStatus: () => ["network", "supplier", "invitation-status"] as const,
  buyerDetails: (connectionId: string) => ["network", "supplier", "buyer-details", connectionId] as const,
  productRequestsOverview: () => ["network", "supplier", "product-requests-overview"] as const,
  resolveInvite: (connectionRequestId: string, token: string) =>
    ["network", "supplier", "resolve-invite", connectionRequestId, token] as const,
  authenticatedResolve: (connectionRequestId: string) =>
    ["network", "supplier", "authenticated-resolve", connectionRequestId] as const,
  pcfLibrary: () => ["network", "supplier", "pcf-library"] as const,
  // Keyed on both pin parts — calculationId alone collides across versions of the same product.
  pcfPreview: (pcfProductId: string, pcfVersion: number) =>
    ["network", "supplier", "pcf-preview", pcfProductId, pcfVersion] as const,
  industries: () => ["network", "supplier", "industries"] as const,
} as const;

// A supplier-side PCF mutation (match/unmatch/submit) can shift a request's status, which affects
// the detail view and the overview, connection list, and supplier stats aggregates. Invalidating the
// shared prefix keeps all of them in sync instead of each mutation hook tracking which aggregates
// it happens to affect.
export const invalidateSupplierNetworkQueries = (queryClient: QueryClient): Promise<void> =>
  queryClient.invalidateQueries({ queryKey: supplierQueryKeys.all });
